var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',[_vm._m(0),(_vm.games)?_c('div',[_c('list',{attrs:{"games":_vm.games,"is-paged":false,"favorites":_vm.games},on:{"removeFavorite":_vm.removeFavorite}})],1):_c('div',{staticClass:"loading"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-block"},[_c('h2',{staticClass:"header-block_title bold"},[_vm._v("Избранное")])])
}]

export { render, staticRenderFns }